import {oeInterfaceManager} from './oe-interface';
import {OEFeatureAccessTypes, OELicensingEdition} from '../react-oe/oe-types';

export default new class {

    constructor() {
    }

    pack(isConnected, isLicensing, isValid, edition)    {
        return {
            isConnected: isConnected,
            isLicensing: isLicensing,
            isValid: isValid,
            edition: edition
        };
    }

    getLicensingAccess(oe, released) {
        if(typeof(oe) === 'string') {
            let moduleId = oe;
            return this.getLicensingAccess(oeInterfaceManager.getInterface(moduleId), released)
        }

        let isConnected = !released && oe && oe.isReady();
        let isLicensing = config.accessType == OEFeatureAccessTypes.licensing && (!isConnected || oe.sharedInterface.getUIControllerFeatureAccess().isAccessType(oe.Module.FeatureAccessType.licensing));

        return this.pack(
            isConnected,
            isLicensing,
            isLicensing ? (isConnected ? oe.sharedInterface.getUIControllerLicensingManager().isValid() : false) : true,
            isLicensing ? (isConnected ? oe.sharedInterface.getUIControllerLicensingManager().getEdition() : OELicensingEdition.none) : OELicensingEdition.master
        );
    }
}